// @flow
import ModalFormUnavailable from 'components/Modal/ModalFormUnavailable'
import ResourceFill from 'components/ResourceFill'
import { getResponse } from 'queries/responses/services/loadResponses'
import * as React from 'react'
import { Prompt } from 'react-router-dom'
import { toast } from 'react-toastify'

type Props = {
  history: {
    push: (path: string) => void,
  },
  location: {
    search: string,
  },
  match: {
    params: {
      responseId: string,
    },
  },
}

const beforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault()
  event.returnValue = ''
}

function InternalForm({ match, location, history }: Props): React.Node {
  const responseId = match.params.responseId
  const sessionId = 'internal-session'
  const queryParams = new URLSearchParams(location.search)
  const messageCode = queryParams.get('messageCode')

  React.useEffect(() => {
    window.addEventListener('beforeunload', beforeUnload)

    return () => {
      window.removeEventListener('beforeunload', beforeUnload)
    }
  }, [])

  const [sessions, setSessions] = React.useState({
    [sessionId]: {
      id: sessionId,
      responses: [
        {
          name: '',
          created_at: '',
          id: responseId,
          internal_user: null,
          is_archived: false,
          is_submitted: false,
          is_scheduled: false,
          internal_locked: false,
          uid: responseId,
        },
      ],
      isSubmitted: false,
      savedForLater: false,
      messageCode,
    },
  })

  React.useEffect(() => {
    if (sessions[sessionId].savedForLater) {
      history.push('')
      toast.success('Form saved successfully')
    }
  }, [history, sessions])

  React.useEffect(() => {
    if (!messageCode) return

    const fetchResponse = async () => {
      let response: Response
      response = await getResponse(responseId)

      setSessions((sessions) => ({
        [sessionId]: {
          ...sessions[sessionId],
          responses: [response],
          isSubmitted: response.is_submitted,
          customer: response.customer,
          isInternalForm: true,
        },
      }))
    }

    const doFetch = async () => {
      try {
        await await fetchResponse()
      } catch (error) {
        if (error?.detail?.detail === 'Response is already submitted.') {
          history.push(
            `/r/${messageCode}/submitted${history?.location?.search ?? ''}`
          )
        }
      }
    }

    doFetch()
  }, [history, messageCode, responseId])

  if (!!sessions[sessionId].responses[0]?.internal_locked) {
    return (
      <ModalFormUnavailable
        hideButton
        isVisible
        description={`Sorry, this form is not available anymore`}
        title={`Form not available`}
      />
    )
  }

  return (
    <>
      <Prompt
        message={() => 'Changes you made may not be saved.'}
        when={!sessions[sessionId].isSubmitted}
      />
      <ResourceFill
        isPacket={false}
        isTablet={false}
        mode="internal"
        sessionId={sessionId}
        sessions={sessions}
        setSessions={setSessions}
      />
    </>
  )
}

export default InternalForm
